import {Component, ChangeDetectionStrategy} from '@angular/core';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {AsideService} from '../../../core/services/aside.service';
import {Store} from '@ngrx/store';
import {AppState} from '../../../app/app.state';
import {UrlService} from '../../../core/services/url.service';
import {TitleChangedAction} from '../../../core/actions/title.actions';
import {BaseAppComponent} from '../_base-app/base-app.component';
import {App, AppId} from '../../../shared/models/app';
import {SessionService} from '../../../core/services/session.service';
import { PermissionsService } from 'src/core/services/permissions.service';

@Component({
  selector: 'motn-app-tenant-portal',
  templateUrl: './app-tenant-portal.component.html',
  styleUrls: ['./app-tenant-portal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class AppTenantPortalComponent extends BaseAppComponent {
  app: App;
  appId: AppId;


  constructor(
    protected store: Store<AppState>,
    protected route: ActivatedRoute,
    protected session: SessionService,
    protected permissionsService: PermissionsService,
    private asideService: AsideService,
  ) {
    super(store, route, session, permissionsService);
  }


  protected onInit() {
  }


  protected onDestroy() {
  }


  protected updateTitle() {
    this.store.dispatch(new TitleChangedAction(
      '',
      this.app.Name,
      [{text: this.app.Config?.Subtitle?.Text}],
      this.app.Config?.Location,
    ));
  }


  protected updateAside() {
    this.asideService.replaceContextSections([
      {
        name: 'Tenant Portal',
        items: [
          {
            text: 'Dashboard',
            path: UrlService.makeTenantPortalDashboardUrl(this.appId),
          },
          // {
          //   text: 'Contact Landlord',
          //   path: UrlService.makeTenantPortalContactLandlordUrl(this.appId),
          // },
        ],
      },
    ]);
  }
}
